module.exports = __webpack_public_path__ + "images/patterns/dark/WaveSquare.3c7c124380aac9be7e97.svg";